import DateFnsUtils from "@date-io/date-fns";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, TextField, Typography } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { FollowUp } from "./FollowUps";

interface FollowUpModalProps {
	onClose: Function;
	record?: FollowUp;
}

export default function FollowUpModal(props: FollowUpModalProps) {
	const m = props.record;
	const [name, setName] = React.useState(m?.BuildingName ?? "");
	const [addr, setAddr] = React.useState(m?.Address ?? "");
	const [c1Name, setC1Name] = React.useState(m?.Contact1Name ?? "");
	const [c1Phone, setC1Phone] = React.useState(m?.Contact1Phone ?? "");
	const [c1Email, setC1Email] = React.useState(m?.Contact1Email ?? "");
	const [c2Name, setC2Name] = React.useState(m?.Contact2Name ?? "");
	const [c2Phone, setC2Phone] = React.useState(m?.Contact2Phone ?? "");
	const [c2Email, setC2Email] = React.useState(m?.Contact2Email ?? "");
	const [c3Name, setC3Name] = React.useState(m?.Contact3Name ?? "");
	const [c3Phone, setC3Phone] = React.useState(m?.Contact3Phone ?? "");
	const [c3Email, setC3Email] = React.useState(m?.Contact3Email ?? "");
	const [numLand, setNumLand] = React.useState(m?.Landings ?? "");
	const [attend, setAttend] = React.useState(m?.DateAssessed ?? (null as Date));
	const [contract, setContract] = React.useState(m?.DateContract ?? (null as Date));
	const [maint, setMaint] = React.useState(m?.Maintenance ?? false);
	const [modern, setModern] = React.useState(m?.Modern ?? false);
	const [repair, setRepair] = React.useState(m?.Repair ?? false);
	const [lost, setLost] = React.useState(m?.Lost ?? false);
	const [notes, setNotes] = React.useState(m?.Notes ?? "");
	const [fup, setFup] = React.useState(m?.FollowUps ?? "");

	const save = () => {
		const f = {
			FollowUpID: m?.FollowUpID ?? (null as string),
			BuildingName: name,
			Address: addr,
			Contact1Name: c1Name,
			Contact1Phone: c1Phone,
			Contact1Email: c1Email,
			Contact2Name: c2Name,
			Contact2Phone: c2Phone,
			Contact2Email: c2Email,
			Contact3Name: c3Name,
			Contact3Phone: c3Phone,
			Contact3Email: c3Email,
			DateAssessed: attend,
			DateContract: contract,
			Landings: numLand,
			Modernization: modern,
			Maintenance: maint,
			Repair: repair,
			FollowUps: fup,
			Lost: lost,
			Notes: notes,
		};
		fetch("Inspection/SaveFollowUp", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify(f),
		}).then((x) => x.ok && props.onClose());
	};

	return (
		<Dialog maxWidth="lg" fullWidth={true} open={true}>
			<DialogTitle>Follow Up</DialogTitle>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12} style={{ borderBottom: "1px solid #ebebeb" }}>
						<Typography variant="subtitle1">Building Info</Typography>
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Building Name"} value={name} onChange={(event) => setName(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Address"} value={addr} onChange={(event) => setAddr(event.target.value)} />
					</Grid>
					<Grid item xs={12} style={{ borderBottom: "1px solid #ebebeb" }}>
						<Typography variant="subtitle1">Contacts</Typography>
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 1 Name"} value={c1Name} onChange={(event) => setC1Name(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 1 Phone"} value={c1Phone} onChange={(event) => setC1Phone(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 1 Email"} value={c1Email} onChange={(event) => setC1Email(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 2 Name"} value={c2Name} onChange={(event) => setC2Name(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 2 Phone"} value={c2Phone} onChange={(event) => setC2Phone(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 2 Email"} value={c2Email} onChange={(event) => setC2Email(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 3 Name"} value={c3Name} onChange={(event) => setC3Name(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 3 Phone"} value={c3Phone} onChange={(event) => setC3Phone(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"Contact 3 Email"} value={c3Email} onChange={(event) => setC3Email(event.target.value)} />
					</Grid>
					<Grid item xs={12} style={{ borderBottom: "1px solid #ebebeb" }}>
						<Typography variant="subtitle1">Elevators</Typography>
					</Grid>
					<Grid item xs={4}>
						<TextField fullWidth={true} variant="outlined" label={"How Many Landings?"} value={numLand} onChange={(event) => setNumLand(event.target.value)} />
					</Grid>
					<Grid item xs={4}>
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								size="medium"
								style={{ marginLeft: "4px", marginTop: "8px" }}
								autoOk
								fullWidth={true}
								variant="inline"
								label="Date Attended"
								format="MM/dd/yyyy"
								value={attend}
								InputAdornmentProps={{ position: "start" }}
								onChange={(date) => {
									setAttend(date);
								}}
							/>
						</MuiPickersUtilsProvider>
					</Grid>
					<Grid item xs={4}>
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								size="medium"
								style={{ marginLeft: "4px", marginTop: "8px" }}
								autoOk
								fullWidth={true}
								variant="inline"
								label="Date of Contract"
								format="MM/dd/yyyy"
								value={contract}
								InputAdornmentProps={{ position: "start" }}
								onChange={(date) => {
									setContract(date);
								}}
							/>
						</MuiPickersUtilsProvider>
					</Grid>
					<Grid item xs={3}>
						<FormControlLabel label="Maintenance" control={<Checkbox checked={maint} onChange={(event) => setMaint(event.target.checked)}></Checkbox>} labelPlacement="top"></FormControlLabel>
					</Grid>
					<Grid item xs={3}>
						<FormControlLabel label="Modernization" control={<Checkbox checked={modern} onChange={(event) => setModern(event.target.checked)}></Checkbox>} labelPlacement="top"></FormControlLabel>
					</Grid>
					<Grid item xs={3}>
						<FormControlLabel label="Repair" control={<Checkbox checked={repair} onChange={(event) => setRepair(event.target.checked)}></Checkbox>} labelPlacement="top"></FormControlLabel>
					</Grid>
					<Grid item xs={3}>
						<FormControlLabel label="Lost" control={<Checkbox checked={lost} onChange={(event) => setLost(event.target.checked)} />} labelPlacement="top"></FormControlLabel>
					</Grid>
					<Grid item xs={12}>
						<TextField label="Notes" variant="outlined" fullWidth multiline rows={5} value={notes} onChange={(event) => setNotes(event.target.value)}></TextField>
					</Grid>
					<Grid item xs={12}>
						<TextField variant="outlined" fullWidth multiline label="Follow Up" rows={5} value={fup} onChange={(event) => setFup(event.target.value)}></TextField>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" color="primary" onClick={() => props.onClose()}>
					Close
				</Button>
				<Button variant="contained" color="primary" onClick={() => save()}>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
}
